// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"e2732336","284":"f317180b","453":"239b4112","456":"c123b5b7","471":"76d48d04","578":"cca5f78c","818":"8af85259"}[chunkId] + ".chunk.js";
};